import React, { useCallback, useContext, useState } from 'react'
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material'
import PropTypes from 'prop-types'
import { THEMES_ARRAY } from './constants'

import DefaultTheme from './default'
import BlackTheme from './black'
import MangosteenTheme from './mangosteen'
import MangoTheme from './mango'
import RedBeanTheme from './redbean'
import SweetTheme from './sweet'
import BlueTheme from './blue'
import STORAGE_KEYS from '~/constants/localStorage'

/** Get the theme object by theme name */
const themeCreator = (themeValue) => {
  const currentThemeComponent =
    THEMES_ARRAY.find((ele) => ele.value === themeValue)?.nameComponent || 'DefaultTheme'
  return themeMap[currentThemeComponent]
}

const themeMap = {
  DefaultTheme,
  BlackTheme,
  MangosteenTheme,
  RedBeanTheme,
  MangoTheme,
  SweetTheme,
  BlueTheme,
}

const defaultValuesContext = {
  setThemeName: (themeName = '') => {},
  currentThemeObject: {},
}

export const ThemeContext = React.createContext(defaultValuesContext)

const ThemeProvider = (props) => {
  // State to hold the selected theme name
  const ThemeInLocalStorage = localStorage.getItem(STORAGE_KEYS.theme)
  const [themeName, _setThemeName] = useState(ThemeInLocalStorage || 'default')

  const theme = themeCreator(themeName)

  const setThemeName = useCallback((themeName) => {
    localStorage.setItem(STORAGE_KEYS.theme, themeName)
    _setThemeName(themeName)
  }, [])

  const getCurrentThemeObject = () => {
    return THEMES_ARRAY.find((ele) => ele.value === themeName)
  }

  const value = {
    setThemeName,
    currentThemeObject: getCurrentThemeObject(),
  }

  return (
    <ThemeContext.Provider value={value}>
      <StyledEngineProvider injectFirst>
        {/* Your component tree. Now you can override Material UI's styles. */}
        <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>
      </StyledEngineProvider>
    </ThemeContext.Provider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.any,
}

export default ThemeProvider

// Ở các component con sẽ dùng hook này để lấy ra value được truyền qua
export const useThemeContext = () => useContext(ThemeContext)
